import { ArrowDownTrayIcon } from '@heroicons/react/20/solid'
import { useState } from 'react'
import { Navigate, Route, Routes, useMatch } from 'react-router-dom'

import Frame from '@/dealers/components/Frame'
import Action from '@/gf/components/Action'
import Page from '@/gf/components/Page'
import { LinkTabs } from '@/gf/components/next/Tabs'
import ExportOrdersModal from './Reports/ExportOrdersModal'
import OpenQuotes from './Reports/OpenQuotes'
import PartsSales from './Reports/PartsSales'
import Performance from './Reports/Performance'
import Service from './Reports/Service'

const tabs = [
  { name: 'Parts Sales', to: 'parts-sales' },
  { name: 'Open Quotes', to: 'open-quotes' },
  { name: 'Service', to: 'service' },
  { name: 'Performance', to: 'performance' },
]

const Reports = () => {
  const match = useMatch(`reports/:tab`)
  const tab = tabs.find((t) => t.to === match?.params.tab) || { name: '' }
  const [exportModalOpen, setExportModalOpen] = useState(false)

  // The tab strip lives here, not in PartsSales, so the button sharing its row
  // is rendered here too and conditioned on the active tab.
  const showExport = tab.name === 'Parts Sales'

  return (
    <Frame className="bg-gray-50">
      <Page className="!p-12 bg-gray-50">
        <div className="flex flex-col gap-y-6">
          <div className="flex flex-row gap-x-8 items-center">
            {/* LinkTabs renders its links as bare children, so the button gets
                ml-auto rather than the row getting justify-between — otherwise
                the tabs themselves spread out. */}
            <LinkTabs tabs={tabs} selectedTabName={tab.name} />

            {showExport && (
              <Action.S
                onClick={() => setExportModalOpen(true)}
                className="ml-auto flex gap-2 items-center text-sm bg-white hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md shadow-sm"
              >
                <ArrowDownTrayIcon className="h-5 w-5 flex-shrink-0" />
                <span>Download Orders</span>
              </Action.S>
            )}
          </div>

          <Routes>
            <Route path="" element={<Navigate to="parts-sales" replace />} />
            <Route path="parts-sales" element={<PartsSales />} />
            <Route path="open-quotes" element={<OpenQuotes />} />
            <Route path="service" element={<Service />} />
            <Route path="performance" element={<Performance />} />
          </Routes>
        </div>

        {showExport && (
          <ExportOrdersModal open={exportModalOpen} onClose={() => setExportModalOpen(false)} />
        )}
      </Page>
    </Frame>
  )
}

export default Reports
